module.exports = __webpack_public_path__ + "img/d03.847af028.png";